import React, { useCallback } from 'react'

import { useSelector } from 'react-redux'

import type { RecipeUUID, RecipeURN } from '@library/menu-service'

import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'
import { BasketContainer } from 'routes/Menu/components/Basket/BasketContainer'
import { useMenuBasketCta } from 'routes/Menu/context/menuBasketCtaContext'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketMenuUuid, getBasketMenuUrn } from 'selectors/basket'

import { MenuExperienceRecipeDetailOverlay } from '../MenuExperiencePage/MenuExperienceRecipeDetailOverlay'
import {
  MenuExperienceRecipeDetailProvider,
  useMenuExperienceRecipeDetails,
} from '../MenuExperiencePage/menuExperienceRecipeDetailContext'

const BasketWithMenuExperienceRecipeDetails = () => {
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const { labelHTML } = useMenuBasketCta()
  const handleRecipeClick = useCallback(
    (recipeId: RecipeUUID, recipeTitle: string, recipeUrn?: RecipeURN) =>
      openRecipeDetail({
        recipeId,
        recipeUrn,
        title: recipeTitle,
        source: 'basket',
      }),
    [openRecipeDetail],
  )

  return <BasketContainer basketLabelHTML={labelHTML} onRecipeClick={handleRecipeClick} />
}

export const MenuExperienceBasketContainer = () => {
  const { updateRecipePortionsByUuid } = useBasket()
  const basketMenuUuid = useSelector(getBasketMenuUuid)
  const basketMenuUrn = useSelector(getBasketMenuUrn)
  const currentCollectionId = useCurrentCollectionId()
  const currentCollection = useCollection(currentCollectionId)

  return (
    <MenuExperienceRecipeDetailProvider
      key={basketMenuUuid}
      collectionId={currentCollectionId}
      collectionSlug={currentCollection?.slug}
      menuId={basketMenuUuid}
      menuUrn={basketMenuUrn}
      updateRecipePortions={updateRecipePortionsByUuid}
    >
      <BasketWithMenuExperienceRecipeDetails />
      <MenuExperienceRecipeDetailOverlay />
    </MenuExperienceRecipeDetailProvider>
  )
}
